import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { ApiServiceInterface, CrudComponent, CrudTableComponentInterface } from '@hutsix/ngxh6';

export interface PageRow {
    id: string;
    title: string;
    slug: string;
    published: boolean;
    showInMenu: boolean;
    sortOrder: number;
    /** Seeded Information-Hub page (fixed slug, can't be deleted) vs TLC's own page. */
    system: boolean;
}

/**
 * Config → Pages list.
 *
 * A custom row renderer rather than the auto-table, so Delete can be offered on TLC's OWN
 * pages only. The seeded system info pages have link-stable slugs the application entry
 * flow and the homepage depend on, so they must not be removable (the backend refuses it
 * too). The generic ngxh6 form delete button is form-wide - it would show on every row,
 * system pages included - so it is off, and this table drives deletion per row instead,
 * POSTing to PageController::delete the same way the form delete would.
 */
@Component({
    selector: 'app-pages-table',
    templateUrl: './pages-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PagesTableComponent implements CrudTableComponentInterface {
    @Input() public response: any;
    @Input() public crud!: CrudComponent;
    @Input() public complete!: boolean;

    constructor(@Inject('ApiService') private api: ApiServiceInterface) {}

    /**
     * Delete one of TLC's own pages, after confirming. A system page has no button, and
     * the guard here is a backstop in case the markup ever changes - the real protection
     * is the entity's PreRemove, which refuses a system page whatever path the delete takes.
     */
    public remove(item: PageRow): void {
        if (item.system) {
            return;
        }
        if (!confirm(`Delete the page "${item.title}"? This can't be undone.`)) {
            return;
        }
        // POST, not a REST DELETE: this mirrors how the ngxh6 form delete issues its call.
        this.api.post({ url: `/api/page/delete/${item.id}`, data: null }).subscribe(() => this.crud.refreshData());
    }
}
